
export default {
    bind(el, { value }) {
        el.setAttribute('src', value);
    },
}
